import React from "react";
import { useTable, useRowSelect, usePagination } from "react-table";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

interface TableProps {
  columns: any;
  data: any;
  setModal?: any;
  periods?: any;
  owners?: any;
  organisations?: any;
  setFilter?: any;
  filter?: any;
  status?: any;
  title?: any;
  isScorecard?: boolean;
  pageCount?: any;
  handlePagination?: any;
  handleSearch?: any;
  dataSize?: any;
  isOrganisation?: boolean;
  orgTypes?: any;
  companies?: any;
  roles?: any;
}


const Table = ({
  columns,
  data,
  handlePagination,
  dataSize,
  pageCount: controlledPageCount,
}: TableProps) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { selectedRowIds, pageIndex, pageSize },
  }: any = useTable(
    {
      columns,
      data,
      //@ts-ignore
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useRowSelect,
    usePagination,
    (hooks) => {}
  );
  const location = useLocation();

  React.useEffect(() => {
    if (handlePagination) {
      handlePagination({ pageIndex, pageSize });
    }
  }, [handlePagination, pageIndex, pageSize]);

  return (
      <StyledTable>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  style={
                    row.isSelected
                      ? { backgroundColor: "#f7f8ff" }
                      : { backgroundColor: "#fff" }
                  }

                >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <Footer>
          <Total>Total records: {dataSize ? dataSize : data.length}</Total>
          <Paginantion>
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </button>
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </button>
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </button>
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </button>
            <span>
              Page
              <strong>
                {pageIndex + 1} of {pageOptions.length || 1}
              </strong>
            </span>
          </Paginantion>
        </Footer>
      </StyledTable>
  );
};

export default Table;


const StyledTable = styled.div`
grid-column:1/span 2;
  /*padding-top: 2em;*/
  table {
    width: 100%;
    border-spacing: 0;
    padding: 2em;
    /* border: 1px solid black; */
    th {
      font-size: 14px;
      font-weight: bold;
      color: #214160;
      opacity: 1 !important;
      text-align: left;
    }
    tr {
      color: rgba(33, 65, 96, 0.5);
      font-size: 12px;
      &:hover {
        /* background-color: #f7f8ff; */
      }
      :last-child {
        td {
          border-bottom: 1px solid rgba(55, 81, 255, 0.1);
        }
      }

      td {
        :first-child {
          padding: 1rem 0;
          /* width: 2em; */
        }
        :nth-child(2) {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 1.5rem;
      border-bottom: 1px solid rgba(55, 81, 255, 0.1);
      :last-child {
        border-right: 0;
      }
      :first-child {
        padding: 2rem 0;
        /* width: 2em; */
      }
    }
  }
`;


const Total = styled.div`
  display: flex;
  padding: 0.1em 4em;
  color: #214160;
`;

const Paginantion = styled.div`
  padding: 1em 2em;
  button {
    margin: 0.3em;
    font-weight: bolder;
    background-color: #fff;
    border: none;
    font-size: 1em;
    border-radius: 50%;
    height: 3em;
    width: 3em;
    padding: 1em;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #d3d6fe;
    }
  }
  span {
    margin: 1em;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
